import styled from 'styled-components';

const BlockDiv = styled.div`
  display: block;
  margin-top: 12px;
  overflow-x: auto;
`;

export default BlockDiv;
